'use client'
import { useGif, useImmutableChannel } from '@/api/hooks'
import createPlaceholderGif from '@/app/util/gif-skeleton'
import { SubmitButton } from '@/components/button'
import UserContext from '@/context/user-context'
import { cn } from '@/util/cn'
import { useContext, useState } from 'react'
import PrivateToggle from '../private-toggle'
import { CollectionLabel, Divider, PlaceholderImage, cardClassName, floatCollectionImage, inputClassName } from '../ui'
import { CreateCollectionForm } from './form'

type Props = { channel?: string; channelId?: string; gifId?: string }

const CreatePanel = ({ channelId: id, gifId }: Props) => {
    const { user } = useContext(UserContext)
    const { data: channel } = useImmutableChannel(id)
    const { data = createPlaceholderGif() } = useGif(gifId)
    const [displayName, setDisplayName] = useState('')
    const enabled = !!displayName
    const isSubChannel = !!channel?.ancestors?.length
    return channel ? (
        <CreateCollectionForm
            enabled={enabled}
            className="flex flex-col items-center gap-2 p-2 font-bold"
            featuredGif={data}
        >
            <div className={cn(cardClassName, 'mb-2 w-40 bg-giphyIndigo')}>
                <PlaceholderImage src={floatCollectionImage} width={`100%`} className="bg-black/40" />
                <CollectionLabel label={displayName || 'New Collection'} />
            </div>
            <PrivateToggle />
            <input type="hidden" name="user" value={user?.id} />
            <input type="hidden" name="parent" value={channel?.id} />
            <div className="flex w-full flex-1 flex-col">
                <label className="text-giphyLightGrey" htmlFor="channel">
                    Name
                </label>
                <input
                    type="text"
                    spellCheck={false}
                    value={displayName}
                    onChange={(e) => setDisplayName(e.target.value)}
                    placeholder={'Collection Name'}
                    name="display_name"
                    autoComplete="off"
                    autoCorrect="off"
                    className={cn(inputClassName, 'peer/input w-full')}
                />
            </div>
            <Divider />
            <SubmitButton
                className={cn(
                    'w-full cursor-pointer select-none peer-placeholder-shown/input:pointer-events-none peer-placeholder-shown/input:opacity-50',
                    !enabled && 'bg-gradient-grey'
                )}
            >
                Create {isSubChannel ? 'Sub-' : ''}Collection
            </SubmitButton>
        </CreateCollectionForm>
    ) : null
}
export default CreatePanel
